const CAR_HUB_IMAGE_BASE_URL =
  'https://mycle.co.kr/resources/images/car/img_report_car_top_'

/** 리소스 서버 키 규칙: `/`는 제거하고(예: `(F10/F11)`→`(F10F11)`),
 * 한글 자소 분리(NFD) 차이로 키가 어긋나지 않도록 NFC로 정규화한다. */
const sanitize = (value: string) => value.replace(/\//g, '')

export const getCarHubImageUrl = (company: string, carName: string) => {
  return `${CAR_HUB_IMAGE_BASE_URL}${sanitize(company)}_${sanitize(carName)}.png`.normalize(
    'NFC'
  )
}
